import React from 'react';
import { TooltipComponent } from '@/components/common/tooltip';
import { Icon, Typography } from '@/components/common';
import Icons from '@/const/icons';

interface Props {
	statesToModal: (string | undefined)[];
	statesToList: string;
	className?: string;
}

export const EligibleStates: React.FC<Props> = ({
	statesToModal,
	statesToList,
	className,
}) => {
	const statesLength = statesToList.split(',').length;
	return (
		<div className={className}>
			<div className="flex items-center flex-wrap gap-3 ">
				<TooltipComponent
					className="w-fit py-4 px-8 min-w-56 max-w-[17.688rem] justify-start rounded-[20px] bg-white"
					label={
						<div className="text-left">
							<Typography type="regular-16">Eligible States</Typography>
							<Typography type="regular-16" className="opacity-60">
								{statesToModal.join(', ')}.
							</Typography>
						</div>
					}
					showArrow={false}
					align="start"
					alignOffset={20}
					classNameTrigger="!z-0"
					trigger={
						<div className="bg-purple-35 rounded-xl p-[10px] w-fit flex items-center gap-1 h-8">
							<div className="flex items-center gap-2">
								<Icon
									src={Icons.location}
									className="!size-[14px] !text-primary"
								/>
								<Typography type="semibold-12" className="hidden lg:flex">
									Eligible States:
								</Typography>
							</div>
							{statesToList.split(',').map((text, index) => (
								<Typography key={text} type="regular-12">
									{index < statesLength - 1 ? `${text},` : text}
								</Typography>
							))}
						</div>
					}
				/>
			</div>
		</div>
	);
};
